var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.processing)?_c('a',{class:_vm.buttonClass,domProps:{"innerHTML":_vm._s(_vm.buttonContent)},on:{"click":function($event){$event.preventDefault();_vm.call()}}}):_c('span',{class:_vm.cssClassProcessing},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(_vm._s(_vm.computedLabelProcessing)+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cb3676a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/src/components/Triggers/OnOffSwitch.vue
// module id = WTds
// module chunks = 0 1